import React from 'react';
import EmergencyPage from '../Emergencias/EmergencyPage';
import NavigationUser from '../Layouts/Navigation/NavigationUser';

export default function UserEmergencias() {
  return <EmergencyPage NavigationComponent={NavigationUser} />;
}
